import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { listAnalyses, deleteAnalysis } from "../../services/api";
import { useAuth } from "../../hooks/useAuth";
import "./History.css";

export default function History() {
  const { user }    = useAuth();
  const navigate    = useNavigate();
  const [analyses, setAnalyses] = useState([]);
  const [loading,  setLoading]  = useState(true);
  const [search,   setSearch]   = useState("");

  useEffect(() => {
    listAnalyses()
      .then(setAnalyses)
      .finally(() => setLoading(false));
  }, []);

  const filtered = analyses.filter((a) =>
    a.label.toLowerCase().includes(search.toLowerCase()) ||
    (a.location || "").toLowerCase().includes(search.toLowerCase()) ||
    (a.batch    || "").toLowerCase().includes(search.toLowerCase())
  );

  const handleDelete = async (id, e) => {
    e.stopPropagation();
    if (!window.confirm("Remover esta análise?")) return;
    await deleteAnalysis(id);
    setAnalyses((prev) => prev.filter((a) => a.id !== id));
  };

  if (loading) return <div className="history-loading">Carregando análises...</div>;

  return (
    <div className="history-page">
      <div className="history-header">
        <div>
          <h1>Histórico de Análises</h1>
          <p>{analyses.length} análise{analyses.length !== 1 ? "s" : ""} registrada{analyses.length !== 1 ? "s" : ""}</p>
        </div>
        <button className="btn-new" onClick={() => navigate("/nova-analise")}>
          + Nova análise
        </button>
      </div>

      <input
        className="history-search"
        type="text"
        placeholder="Buscar por nome, local ou lote..."
        value={search}
        onChange={(e) => setSearch(e.target.value)}
      />

      {filtered.length === 0 ? (
        <div className="history-empty">
          {search ? "Nenhuma análise encontrada." : "Nenhuma análise registrada ainda."}
        </div>
      ) : (
        <div className="history-list">
          {filtered.map((a) => (
            <div
              key={a.id}
              className="history-item"
              onClick={() => navigate(`/analysis/${a.id}`)}
            >
              <div className="history-item-main">
                <span className="history-label">{a.label}</span>
                <div className="history-tags">
                  {a.location && <span className="tag">{a.location}</span>}
                  {a.batch    && <span className="tag">Lote {a.batch}</span>}
                </div>
              </div>
              <div className="history-item-metrics">
                <div className="hist-metric">
                  <span className="hist-metric-val">{a.mean_mm}</span>
                  <span className="hist-metric-lbl">mm médio</span>
                </div>
                <div className="hist-metric">
                  <span className="hist-metric-val">{a.cv_percent}%</span>
                  <span className="hist-metric-lbl">CV</span>
                </div>
                <div className="hist-metric">
                  <span className="hist-metric-val">{a.count}</span>
                  <span className="hist-metric-lbl">grãos</span>
                </div>
              </div>
              <div className="history-item-right">
                <span className="history-date">
                  {new Date(a.created_at).toLocaleDateString("pt-BR")}
                </span>
                {(user?.is_admin || a.user_id === user?.id) && (
                  <button
                    className="btn-delete"
                    onClick={(e) => handleDelete(a.id, e)}
                    title="Remover análise"
                  >
                    ✕
                  </button>
                )}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
